import { useStore, useStoreMap } from 'effector-react'
import { carModel, Form } from '~/entities/common/Car'
import { usePermissions } from '~/entities/common/viewer'
import {
  carPropertyTypeEnumLabels,
  fuelTypeEnumLabels,
  transmissionEnumLabels,
} from '~/shared/config/constants'
import { formSubmitted, sendFormFx, $car, $id } from './model'

export function EditCar() {
  const { canCarsUpdate } = usePermissions()
  const isSaving = useStore(sendFormFx.pending)
  const isLoading = useStore(carModel.requestFx.pending)
  const carId = useStore($id)

  const defaultValues = useStoreMap($car, (car) => {
    const transmission = car?.getTransmission()
    const fuelType = car?.getFuelType()
    const propertyType = car?.getPropertyType()
    const locationOption = car?.getLocation()?.getOption()

    return {
      ...car?.getAttributes(),
      modelId: car?.getCarModel()?.getOption(),
      brand: car?.getCarModel()?.getCarBrand()?.getOption(),
      colorId: car?.getColor()?.getOption(),
      subdivisionId: car?.getSubdivision()?.getOption(),
      vehicleCategoryId: car?.getVehicleCategory()?.getOption(),
      carRentalId: car?.getCarRental()?.getOption(),
      regionId: car?.getRegion()?.getOption(),
      locationId: locationOption
        ? {
            ...locationOption,
            filters: {
              regionId: car?.getRegion()?.getApiId(),
            },
          }
        : null,
      aggregatorAccountOption: car?.getAggregatorAccount()?.getOption(),
      estimatedCost: car?.getEstimatedCost(),
      transmission: transmission
        ? {
            id: transmission,
            label: transmissionEnumLabels[transmission],
          }
        : null,
      fuelType: fuelType
        ? {
            id: fuelType,
            label: fuelTypeEnumLabels[fuelType],
          }
        : null,
      propertyType: propertyType
        ? {
            id: propertyType,
            label: carPropertyTypeEnumLabels[propertyType],
          }
        : null,
    }
  })

  return (
    <Form
      defaultValues={defaultValues}
      onSuccess={formSubmitted}
      isSubmitting={isSaving}
      canEdit={canCarsUpdate}
      isLoading={isLoading}
      isView
      carId={carId}
    />
  )
}
